import script from "./ViewAllTalks.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAllTalks.vue?vue&type=script&setup=true&lang=js"

import "./ViewAllTalks.vue?vue&type=style&index=0&id=32c8191a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32c8191a"]])

export default __exports__